import { $http } from "@/utils/http";
import {
    CHANGE_INVOICE_LOADING,
    CHANGE_POPUP_CONFIRM_PAYMENT,
    CHANGE_TRANSACTION_LOADING,
    RESET_PAYMENT,
    SET_INVOICE,
    SET_TRANSACTION,
} from "../mutation-types";

import { CREATE_INVOICE, CREATE_TRANSACTION } from "../action-types";

import { fixBody } from "@/helpers/variables";

const state = {
    invoiceResult: null,
    isInvoiceLoading: false,

    transactionResult: null,
    isTransactionLoading: false,

    productId: null,
    showPopupConfirmPayment: false,
    popupConfirmPaymentLoading: false,
};

const getters = {
    invoiceResult: state => state.invoiceResult,
    isInvoiceLoading: state => state.isInvoiceLoading,

    transactionResult: state => state.transactionResult,
    isTransactionLoading: state => state.isTransactionLoading,

    productId: state => state.productId,
    showPopupConfirmPayment: state => state.showPopupConfirmPayment,
    popupConfirmPaymentLoading: state => state.popupConfirmPaymentLoading,
};

const actions = {
    [CREATE_INVOICE]: async ({ commit }, payload) => {
        try {
            commit(CHANGE_INVOICE_LOADING, true);

            const response = await $http.post("v1/invoices", payload);
            commit(SET_INVOICE, response.data.data);
            return response.data.data;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_INVOICE_LOADING, false);
        }
    },
    [CREATE_TRANSACTION]: async ({ commit }, payload) => {
        try {
            commit(CHANGE_TRANSACTION_LOADING, true);

            const response = await $http.post("v1/transactions", payload);
            if (response.data?.data?.value) {
                commit(SET_INVOICE, response.data.data);
            }
            commit(SET_TRANSACTION, response.data);

            return response.data;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_TRANSACTION_LOADING, false);
        }
    },
};

const mutations = {
    [SET_INVOICE](state, data) {
        state.invoiceResult = data;
    },
    [CHANGE_INVOICE_LOADING](state, status) {
        state.isInvoiceLoading = status;
    },
    [SET_TRANSACTION](state, data) {
        state.transactionResult = data;
    },
    [CHANGE_TRANSACTION_LOADING](state, status) {
        state.isTransactionLoading = status;
    },
    [RESET_PAYMENT](state, id) {
        state.productId = null;
        state.orderResult = null;
        state.invoiceResult = null;
        state.transactionResult = null;
    },
    [CHANGE_POPUP_CONFIRM_PAYMENT](state, status) {
        state.showPopupConfirmPayment = status;
        fixBody(status);
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
